import { AppThunkAction } from "..";
import { KnownAction, ISocialMediaStatus, REPIQ_SOCIAL_MEDIA_STATUS, SHOW_LOADER } from "./types";
import * as services from "../service";
import { groupByValue } from "../../util/common";

export const actionCreators = {
    getUserNetworkStatus:
        (forceReload: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            dispatch({ type: SHOW_LOADER, isLoading: true });
            const appState = getState();
            if (
                forceReload === false &&
                appState &&
                appState.repIQSocialMediaStatusState &&
                appState.repIQSocialMediaStatusState.socialMediaStatus &&
                appState.repIQSocialMediaStatusState.socialMediaStatus.length > 0
            ) {
                dispatch({ type: SHOW_LOADER, isLoading: false });
            } else {
                services
                    .getUserNetworkStatus()
                    .then((data) => {
                        let results: ISocialMediaStatus[] = [];
                        if (data && data.length > 0) {
                            let groupByNetworkID = groupByValue(data, "displayOrder");

                            Object.keys(groupByNetworkID).forEach((key: any) => {
                                let obj = groupByNetworkID[key];
                                let socialMediaStatus: ISocialMediaStatus = {
                                    NetworkName: "",
                                    NetworkID: 0,
                                    LastScanDate: "01/01/1900",
                                    Status: "",
                                    Username: "",
                                    MinimumWordCountFoundForAIProcess: false,
                                    IsPersonalityAnalysing: false,
                                    Agreeableness: 0,
                                    Conscientiousness: 0,
                                    EmotionalRange: 0,
                                    Extraversion: 0,
                                    OpennessToExperiences: 0,
                                    DisplayOrder: 0,
                                };
                                obj.forEach((row: any) => {
                                    socialMediaStatus.NetworkName = row.networkName;
                                    socialMediaStatus.NetworkID = row.networkID;
                                    socialMediaStatus.LastScanDate = row.lastScanDate;
                                    socialMediaStatus.MinimumWordCountFoundForAIProcess = row.minimumWordCountFoundForAIProcess;
                                    socialMediaStatus.IsPersonalityAnalysing = row.isPersonalityAnalysing;
                                    socialMediaStatus.Status = row.status;
                                    socialMediaStatus.Username = row.username;
                                    socialMediaStatus.DisplayOrder = row.displayOrder;

                                    if (row.category === "OpennessToExperiences") {
                                        socialMediaStatus.OpennessToExperiences = row.result;
                                    } else if (row.category === "Conscientiousness") {
                                        socialMediaStatus.Conscientiousness = row.result;
                                    } else if (row.category === "Extraversion") {
                                        socialMediaStatus.Extraversion = row.result;
                                    } else if (row.category === "Agreeableness") {
                                        socialMediaStatus.Agreeableness = row.result;
                                    } else if (row.category === "EmotionalRange") {
                                        socialMediaStatus.EmotionalRange = row.result;
                                    }
                                });
                                if (socialMediaStatus.Status === "Connected") {
                                    results.push(socialMediaStatus);
                                }
                            });
                        }
                        dispatch({ type: REPIQ_SOCIAL_MEDIA_STATUS, socialMediaStatus: results });
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    })
                    .catch(function (error) {
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    });
            }
        },
};
